import i18n from '../../i18n'

export const fillterMenu = [
  {
    id: 1,
    label: 'title',
    name: i18n.t('pages.posters.filter-title')
  }
]
